<template>
  <base-modal
    name="repetitiveMeeting"
    width="380"
    @closeRepetitiveMeeting="$emit('closeRepetitiveMeeting')"
  >
    <template #body>
      <div class="px-10">
        <div class="flex justify-end">
          <close-icon @click.native="closeHandler()" class="mt-20 cursor-pointer" />
        </div>
        <div class="flex mt-20">
          <p class="text-title font-bold">
            {{ $t('repeat') }} {{ $t('meeting').toLocaleLowerCase() }}
          </p>
        </div>
        <div class="flex flex-col items-center">
          <div class="bg-secondary w-318 h-200 shadow-lg my-20 rounded">
            <div class="flex justify-center items-center">
              <div
                class="h-48 w-60 p-16 flex justify-center mx-16 cursor-pointer font-semibold"
                :class="activeMenuClass('daily')"
                @click="activeMenuHandler('daily')"
              >
                <p>{{ $t('daily') }}</p>
              </div>
              <div
                class="h-48 w-60 p-16 flex justify-center mx-16 cursor-pointer font-semibold"
                :class="activeMenuClass('weekly')"
                @click="activeMenuHandler('weekly')"
              >
                <p>{{ $t('weekly') }}</p>
              </div>
              <!-- <div
              class="h-48 w-60 p-16 flex justify-center mx-16"
              :class="activeMenuClass('monthly')"
              @click="activeMenuHandler('monthly')"
            >
              <p>{{ $t('monthly') }}</p>
            </div> -->
            </div>
            <div v-if="repetitiveTotalInfo.type === 'daily'">
              <p class="text-title px-16 py-15 text-16 font-medium">
                {{ $t('repeat_every') }}
                <input
                  type="number"
                  class="border border-default w-50 h-32 rounded-sm bg-secondary
                   text-center cursor-pointer text-16 font-medium"
                  v-model="repetitiveTotalInfo.repeat_every"
                  min="1"
                  max="9999"
                />
                {{ $t('days') }}
              </p>
            </div>
            <div v-if="repetitiveTotalInfo.type === 'weekly'">
              <p class="text-title px-16 py-15 text-16 font-medium">
                {{ $t('repeat_every') }}
                <input
                  type="number"
                  class="border border-default w-50 h-32 rounded-sm bg-secondary
                   text-center cursor-pointer text-16 font-medium"
                  v-model="repetitiveTotalInfo.repeat_every"
                  min="1"
                  max="9999"
                />
                {{ $t('weeks') }}
              </p>
              <p class="px-16 py-10 text-16 font-medium">{{ $t('repeat_on') }}</p>
              <div class="px-16">
                <div class="flex justify-between">
                  <div
                    v-for="weekDay in weekDays"
                    :key="weekDay"
                    class="week-number"
                    @click="repetitiveWeekDaysHandler(weekDay)"
                    :class="activeDayClass(weekDay)"
                  >
                    <p :title="$t(weekDay)">
                      {{ $t(weekDay).substring(0, 1) }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div v-if="repetitiveTotalInfo.type === 'monthly'">
            <p class="text-title px-20 py-15">
              {{ $t('repeat_every') }}
              <input
                type="number"
                class="border border-default w-50 h-32 rounded-sm bg-secondary text-center"
                v-model="repetitiveTotalInfo.repeat_every"
              />
              {{ $t('months') }}
            </p>
          </div> -->
          </div>
          <div class="bg-secondary w-318 h-200 shadow-lg my-20 rounded">
            <div class="flex mt-20">
              <p class="text-title font-bold mx-16 text-18">{{ $t('end') }}</p>
            </div>
            <div class="mx-16 mt-15 flex gap-x-5 items-center">
              <base-radio-button
                :id="`never`"
                value="never"
                name="never"
                :label="$t('never')"
                class="font-medium text-16"
                v-model="repetitiveTotalInfo.end_type"
              />
              <p
              class="font-medium text-16"
                :class="{
                  'text-disabled':
                    repetitiveTotalInfo.end_type === 'end_after' ||
                    repetitiveTotalInfo.end_type === 'end_on',
                }"
              >
                ({{ $t('until_a_year') }})
              </p>
            </div>
            <div class="mx-16 mt-10 flex items-center justify-between">
              <base-radio-button
                :id="`end_on`"
                value="end_on"
                name="end_on"
                class="font-medium text-16"
                :label="$t('on_day').charAt(0).toLocaleUpperCase() + $t('on_day').slice(1)"
                v-model="repetitiveTotalInfo.end_type"
              />
              <div>
                <input
                  type="text"
                  class="custom-input end-date cursor-pointer"
                  placeholder="select date"
                  v-model="formatEndRepeatDate"
                  :class="{
                    'text-disabled':
                      repetitiveTotalInfo.end_type === 'end_after' ||
                      repetitiveTotalInfo.end_type === 'never',
                  }"
                />

                <date-picker
                  v-model="repetitiveTotalInfo.end_on"
                  :disabled="
                    repetitiveTotalInfo.end_type === 'end_after' ||
                    repetitiveTotalInfo.end_type === 'never'
                  "
                  format="YYYY-MM-DD"
                  custom-input=".custom-input"
                  :locale="calendar === 'Solar' ? 'fa' : 'en'"
                  :locale-config="{
                    fa: {
                      displayFormat: 'jYYYY-jMM-jDD',
                      lang: { label: 'شمسی' },
                    },
                    en: {
                      displayFormat: 'YYYY-MM-DD',
                      lang: { label: 'Gregorian' },
                    },
                  }"
                />
              </div>
            </div>
            <div class="mx-16 mt-10 flex items-center justify-between">
              <base-radio-button
                :id="`end_after`"
                value="end_after"
                name="end_after"
                :label="$t('after')"
                class="font-medium text-16"
                v-model="repetitiveTotalInfo.end_type"
              />
              <div class="flex items-center justify-start w-167 gap-x-20">
                <input
                  type="number"
                  class="border border-default w-50 h-32 rounded-sm bg-secondary
                   text-center cursor-pointer"
                  :class="{
                    'text-disabled':
                      repetitiveTotalInfo.end_type === 'end_on' ||
                      repetitiveTotalInfo.end_type === 'never',
                  }"
                  v-model="repetitiveTotalInfo.end_after"
                  :disabled="
                    repetitiveTotalInfo.end_type === 'end_on' ||
                    repetitiveTotalInfo.end_type === 'never'
                  "
                  min="1"
                  max="9999"
                />
                <p
                  :class="{
                    'text-disabled':
                      repetitiveTotalInfo.end_type === 'end_on' ||
                      repetitiveTotalInfo.end_type === 'never',
                  }"
                >
                  {{ $t('occurrences') }}
                </p>
              </div>
            </div>
          </div>
          <base-button
            buttonType="primary"
            width="full"
            height="48"
            radius="default"
            @click.native="saveRepeatInfoHandler()"
          >
            <template #text>{{ $t('save') }} </template>
          </base-button>
        </div>
      </div>
    </template>
  </base-modal>
</template>
<script>
import { mapGetters } from 'vuex';
import BaseButton from '@/components/base/BaseButton.vue';
import BaseModal from '@/components/modals/BaseModal.vue';
import CloseIcon from '@/assets/icons/vue/close_normal.vue';
import BaseRadioButton from '@/components/base/BaseRadioButton.vue';
import VuePersianDatetimePicker from 'vue-persian-datetime-picker';

const moment = require('moment-jalaali');

export default {
  name: 'repetitiveMeeting',
  components: {
    BaseButton,
    BaseModal,
    CloseIcon,
    BaseRadioButton,
    datePicker: VuePersianDatetimePicker,
  },
  props: {
    startDate: {
      type: [String, Date],
    },
    calendar: {
      type: String,
    },
    meetingInfo: {
      type: Object,
    },
  },
  data() {
    return {
      repetitiveTotalInfo: {
        type: 'daily',
        repeat_every: 1,
        repeat_on_days: [],
        end_type: 'never',
        end_on: '',
        end_after: 1,
        is_changed: false,
      },
    };
  },
  mounted() {
    this.getRepetitiveMeetingInfo();
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    const day = String(currentDate.getDate()).padStart(2, '0');
    this.repetitiveTotalInfo.end_on = `${year}-${month}-${day}`;
  },
  computed: {
    ...mapGetters({
      theme: 'getTheme',
      defaultCompany: 'getDefaultCompany',
      currentPermission: 'permissions/getPermissions',
    }),
    weekDays() {
      if (this.calendar === 'Solar') {
        return ['saturday', 'sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday'];
      }
      return ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
    },
    dateDirection() {
      if (this.calendar === 'Solar' && this.$i18n.locale !== 'fa' && this.$i18n.locale !== 'ar') {
        return 'dir-rtl';
      }
      if (
        this.calendar === 'Gregorian'
        && (this.$i18n.locale === 'fa' || this.$i18n.locale === 'ar')
      ) {
        return 'dir-ltr';
      }
      if (this.calendar === 'Solar' && (this.$i18n.locale === 'fa' || this.$i18n.locale === 'ar')) {
        return 'dir-rtl';
      }
      return 'dir-ltr';
    },
    formatEndRepeatDate() {
      if (this.calendar === 'Solar') {
        return moment(this.repetitiveTotalInfo.end_on).format('jYYYY-jMM-jDD');
        // eslint-disable-next-line no-else-return
      } else {
        return moment(this.repetitiveTotalInfo.end_on).format('YYYY-MM-DD');
      }
    },
    startDateWeekDay() {
      moment.locale('en');
      return moment(this.startDate).format('dddd').toLowerCase();
    },
  },
  watch: {
    startDate(Val) {
      if (!this.$route.params.reserveId) {
        this.repetitiveTotalInfo.end_on = Val;
      }
    },
    'repetitiveTotalInfo.type': {
      handler(newValue) {
        if (newValue === 'daily') {
          this.repetitiveTotalInfo.repeat_on_days = [];
        }
      },
    },
  },
  methods: {
    getRepetitiveMeetingInfo() {
      if (this.$route.params.reserveId && this.meetingInfo.is_repetitive) {
        this.meetingInfo.repetitive_meta.is_changed = false;
        this.repetitiveTotalInfo = JSON.parse(JSON.stringify(this.meetingInfo.repetitive_meta));
        this.repetitiveInfoHandler();
      }
    },
    saveRepeatInfoHandler() {
      this.repetitiveInfoHandler();
      this.closeModals('repetitiveMeeting');
    },
    closeHandler() {
      this.closeModals('repetitiveMeeting');
      this.$emit('closeRepetitiveMeeting');
    },
    repetitiveInfoHandler() {
      this.repetitiveTotalInfo.is_changed = false;
      this.$emit('repeat', this.repetitiveTotalInfo);
      if (
        this.repetitiveTotalInfo.type === 'daily'
        && (this.repetitiveTotalInfo.repeat_every === 1
          || this.repetitiveTotalInfo.repeat_every === '1')
        && this.repetitiveTotalInfo.end_type === 'never'
      ) {
        this.$emit('daily');
      } else if (
        this.repetitiveTotalInfo.type === 'weekly'
        && (this.repetitiveTotalInfo.repeat_every === 1
          || this.repetitiveTotalInfo.repeat_every === '1')
        && this.repetitiveTotalInfo.end_type === 'never'
        && this.startDateWeekDay === this.repetitiveTotalInfo.repeat_on_days[0]
        && this.repetitiveTotalInfo.repeat_on_days.length === 1
      ) {
        this.$emit('weekly');
      }
    },
    activeMenuHandler(menuItem) {
      this.repetitiveTotalInfo.type = menuItem;
    },
    activeMenuClass(menuItem) {
      return this.repetitiveTotalInfo.type === menuItem ? 'active-item' : '';
    },
    closeModals(...modals) {
      modals.map((modalName) => this.$store.dispatch('modal/close', modalName));
    },
    activeDayClass(data) {
      return this.repetitiveTotalInfo.repeat_on_days?.includes(data) ? 'active-week-day' : '';
    },
    repetitiveWeekDaysHandler(data) {
      if (!this.repetitiveTotalInfo.repeat_on_days.includes(data)) {
        this.repetitiveTotalInfo.repeat_on_days.push(data);
      } else if (this.repetitiveTotalInfo.repeat_on_days.includes(data)) {
        const INDEX = this.repetitiveTotalInfo.repeat_on_days.indexOf(data);
        if (INDEX > -1) {
          this.repetitiveTotalInfo.repeat_on_days.splice(INDEX, 1);
        }
      }
    },
  },
};
</script>
<style scoped>
.active-week-day {
  @apply bg-primaryColor font-bold;
  color: white !important;
}
.active-item {
  @apply border-b-2 border-primary;
}
.dir-rtl {
  direction: rtl;
}
.dir-ltr {
  direction: ltr;
}
.week-number {
  @apply w-36 h-36 flex justify-center items-center border border-default rounded-full
   cursor-pointer text-16 text-subtitle;
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type='number'] {
  -moz-appearance: textfield;
}
.disabled-end {
  @apply text-disabled;
}
.end-date {
  @apply border border-default w-167 h-40 text-center rounded-sm bg-secondary;
}
</style>
